export default "__VITE_ASSET__DkEGgQBp__"